export default "__VITE_ASSET__Yc$SkOCI__"